var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 16H0.875C0.391562 16 0 15.6022 0 15.1111V0.888889C0 0.397778 0.391562 0 0.875 0H7V16Z",
    fill: "#01209F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.1111C21 15.6022 20.6084 16 20.125 16H14V0H20.125C20.6084 0 21 0.397778 21 0.888889V15.1111Z",
    fill: "#EF4234"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0H7V16H14V0Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance);
export default __webpack_public_path__ + "static/media/france.4b69dbc5.svg";
export { ForwardRef as ReactComponent };